import TargetChallengeTransactionLinkService from 'services/application/transaction/transactionLink/subServices/TargetChallengeTransactionLinkService';

export default {
	'services.targetChallengeTransactionLinkService': {
		class: TargetChallengeTransactionLinkService,
	},
};
